import { ParkSelectView } from './ParkSelect.view';

export const ParkSelect = ParkSelectView;
